<div class="container-box">
  <app-table-header tableTitle="Agenzie sub-agenti" (btnUpdateClick)="loadSubagentAgency()">
    <app-button-create-new-sub-agent action-button></app-button-create-new-sub-agent>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="subagentAgencyTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
